<template>
  <footer class="bg-[#F1F5F9] py-14">
    <div class="mx-auto flex max-w-6xl flex-col px-4 py-6">
      <div
        class="flex flex-col gap-6 sm:flex-row sm:items-start sm:justify-between"
      >
        <div>
          <div class="flex items-center gap-2 text-lg font-bold">
            <!-- Custom SVG -->
            <LogoIconSvg filled :font-controlled="false" class="h-8 w-8" />
            <LogoTextSvg
              color="#306294"
              :font-controlled="false"
              class="h-6 w-16"
            />
          </div>
          <div class="mt-3 text-sm text-gray-400">
            Bring your old documents up to date—instantly.
          </div>
        </div>

        <Button v-slot="slotProps" as-child>
          <RouterLink
            to="/contact-us"
            :class="slotProps.class"
            class="border-0! bg-white! font-semibold! whitespace-nowrap! text-black! hover:bg-slate-100!"
          >
            Contact Us
          </RouterLink>
        </Button>
      </div>

      <hr class="mt-9 text-[#E6E6EA]" />
      <div
        class="mt-6 flex flex-col gap-6 md:flex-row md:items-center md:justify-between"
      >
        <div class="flex gap-8">
          <a
            href="https://www.facebook.com/profile.php?id=61575410131451"
            target="_blank"
            rel="noopener noreferrer"
            class="transition-opacity hover:opacity-80"
          >
            <SvgoFacebook filled :font-controlled="false" class="h-6 w-6" />
          </a>
          <a
            href="https://www.instagram.com/bruce_reformatter/"
            target="_blank"
            rel="noopener noreferrer"
            class="transition-opacity hover:opacity-80"
          >
            <SvgoInstagram filled :font-controlled="false" class="h-6 w-6" />
          </a>
          <a
            href="https://linkedin.com/company/bruce-reformatter/"
            target="_blank"
            rel="noopener noreferrer"
            class="transition-opacity hover:opacity-80"
          >
            <SvgoLinkedin filled :font-controlled="false" class="h-6 w-6" />
          </a>
        </div>

        <div
          class="flex items-center gap-8 text-sm leading-4 font-semibold tracking-normal"
        >
          <NuxtLink
            v-for="item in items"
            :key="item.route"
            v-slot="{ isActive }"
            :to="item.route"
            class="relative bg-transparent! py-2 text-[#306294] no-underline"
          >
            {{ item.label }}

            <span
              class="absolute bottom-0 left-0 h-px bg-[#306294] transition-all duration-300"
              :class="isActive ? 'w-full' : 'w-0'"
            />
          </NuxtLink>
        </div>
      </div>

      <div class="text-color-tertiary pt-4 text-right text-xs opacity-5">
        v{{ version }}
      </div>
    </div>
  </footer>
</template>

<script setup lang="ts">
import pkg from '@/../package.json';
import LogoIconSvg from '@/assets/images/logo-icon.svg';
import LogoTextSvg from '@/assets/images/logo-text.svg';
import Button from 'primevue/button';
import { RouterLink } from 'vue-router';

const { version } = pkg;
const items = [
  { label: 'Privacy Policy', route: '/privacy-policy' },
  { label: 'Terms of Service', route: '/terms-of-use' },
];
</script>
